module.exports = __webpack_public_path__ + "img/Timeline2012.0299c4a8.png";